import type { IconData } from '@stacksjs/iconify-core'

export const bookmark: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M18 22a1 1 0 0 1-.5-.134L12 18.694l-5.5 3.172A1 1 0 0 1 5 21V5a3.003 3.003 0 0 1 3-3h8a3.003 3.003 0 0 1 3 3v16a1 1 0 0 1-1 1\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default bookmark
